export default "__VITE_ASSET__BSlRE28R__";